import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconLogo, getTranslation } from '@resy/ui-kitchen';
import HamburgerButton from '../../../../svg/dynamic/hamburger.svg';
import './MobileMenu.scss';

const MobileMenu = ({
  drawerClickHandler, show,
}) => (
  <div className="GDA__MobileMenu__navigation">
    <Button
      href="/"
      className="ResyAmexGDAHeader__resy-logo"
      variant="no-style"
      aria-label={getTranslation({
        translationKey: 'resy_logo_click_home',
        fallback: 'Resy Logo. Click to go home.',
      })}
    >
      <IconLogo height="30" width="68" />
    </Button>
    <div className="GDA__MobileMenu__toggle-button">
      <Button
        variant="no-style"
        type="button"
        data-test-id="amexGDA_mobile-header_button-toggle-menu"
        className="GDA__MobileMenu__toggle-button--button toggle"
        onClick={drawerClickHandler}
        aria-label="Mobile menu"
        aria-haspopup="true"
        aria-expanded={show}
      >
        <HamburgerButton className="GDA__MobileMenu__hamburger" />
      </Button>
    </div>
  </div>
);

MobileMenu.propTypes = {
  drawerClickHandler: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default MobileMenu;
